<template>
  <div>
    <!-- <div class="dategroup">
      <van-row type="flex">
        <van-col span="5" v-for="(date, index) in dates" :key="date.date" class="margin-right-15">
          <div
            class="dategroup-date"
            :class="{'dategroup-selected':selectedDate===date.date,'dategroup-disabled':date.disable}"
            @click="dateChanged(index)"
          >
            <div>
              <div>{{date.text.substr(0,2) }}</div>
              <div v-if="date.disable">不可订</div>
            </div>
          </div>          
        </van-col>
        <van-col v-if="moreDate" span="6">
          <div class="dategroup-date" @click="selectMoreDate">
            <span>更多日期</span>
            <van-icon name="arrow"/>
          </div>
        </van-col>
      </van-row>
    </div> -->
    <div class="row">
      <div
        class="kjmmjknmxer cen mr15"
        v-for="(date,idx) in dates"
        :key="date.date"
       
        :class="{'act':selectedDate===date.date,'disabled':date.disable}"
         @click="dateChanged(idx)"
      >
        <p class="fz12 z3 dfgdt">{{date.text.substr(0,2) }}</p>
        <div class="cen btm zts pt10">{{date.disable? '不可订' : date.text.substr(3)}}</div>
      </div>
      <div class="col">
        <div class="kjmmjknmxer cen mr15 w100" @click="selectMoreDate">
          <p class="fz12 z3 dfgdt">更多</p>
          <div class="cen btm zts fz16 pt5">
            <i class="f_i gengdder"></i>
          </div>
        </div>
      </div>
    </div>
    <van-calendar v-model="showDateTimePicker" @confirm="confirmMoreDate" color="#810102" class="calendar"/>
    <!-- <van-popup v-model="showDateTimePicker" position="bottom">
      <calendar
        :ago-day-hide="minDateTime"
        :future-day-hide="maxDateTime"
        :disabled-weeks="disabledWeeks"
        :disabled-dates="disabledDates"
        @choseDay="confirmMoreDate"
      ></calendar>
    </van-popup> -->
  </div>
</template>

<script>
import calendar from "./calendar/calendar.vue";
import moment from "moment";
moment.updateLocale("zh-CN", {
  weekdaysShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
});

export default {
  name: "date-selector",
  components: {
    calendar,
  },
  data() {
    return {
      selectedDate: this.value,
      showDateTimePicker: false,
      idjjsd: 0,
    };
  },
  props: {
    value: {
      type: String,
      default: moment().format("YYYY-MM-DD"),
    },
    dates: {
      type: Array,
      default() {
        let now = moment();
        let tomorrow = moment().add(1, "days");
        let afterTomorrow = moment().add(2, "days");
        return [
          {
            date: now.format("YYYY-MM-DD"),
            text: "今天" + now.format("MM-DD"),
            disable: false,
          },
          {
            date: tomorrow.format("YYYY-MM-DD"),
            text: "明天" + tomorrow.format("MM-DD"),
            disable: false,
          },
          {
            date: afterTomorrow.format("YYYY-MM-DD"),
            text: afterTomorrow.format("MM-DD") + afterTomorrow.format("ddd"),
            disable: false,
          },
        ];
      },
    },
    minDate: {
      type: Date,
      default() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
      },
    },
    maxDate: {
      type: Date,
      default() {
        const date = moment().add(30, "days").toDate();
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      },
    },
    moreDate: {
      type: Boolean,
      default: true,
    },
    disabledWeeks: {
      type: Array,
      default() {
        return [];
      },
    },
    disabledDates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    minDateTime() {
      return (this.minDate.getTime() / 1000).toString();
    },
    maxDateTime() {
      return (this.maxDate.getTime() / 1000).toString();
    },
  },
  watch: {
    value: function (val) {
      this.selectedDate = val;
    },
  },
  methods: {
    dateChanged(index) {
      let date = this.dates[index];
      if (date.disable) {
        return;
      }
      this.selectedDate = date.date;
      this.$emit("input", this.selectedDate);
    },
    selectMoreDate() {
      this.showDateTimePicker = true;
    },
    confirmMoreDate(value) {
      this.showDateTimePicker = false;

      value = moment(value);
      this.selectedDate = value.format("YYYY-MM-DD");
      this.$emit("input", this.selectedDate);
      if (this.dates.filter((d) => d.date == this.selectedDate).length <= 0) {
        this.dates[this.dates.length - 1] = {
          date: this.selectedDate,
          text: value.format("MM-DD") + value.format("ddd"),
          disable: false,
        };
      }
    },
    cancelMoreDate() {
      this.showDateTimePicker = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dategroup {
  background-color: white;
  font-size: 12px;
  padding: 10px 15px;

  &-date {
    border: 1px solid rgb(204, 206, 210);
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  &-selected {
    border-color: #38f;
    background: url("./../assets/active_bg.png") bottom right no-repeat;
  }

  &-disabled {
    border-color: rgb(221, 223, 225);
    color: rgb(221, 223, 225);
  }
}

.margin-right-15 {
  margin-right: 15px;
}
.calendar{
  z-index: 10000;
}
</style>